export default "__VITE_PUBLIC_ASSET__511f3dc9__"